"use strict";
/**
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoGasSetting = void 0;
exports.AutoGasSetting = {
    Slow: 'Slow',
    Average: 'Average',
    Fast: 'Fast',
};
